import { createSlice } from '@reduxjs/toolkit'

export const FollowingSlice = createSlice({
  name: 'follow',
  initialState: {
    value: true,
  },
  reducers: {
    followAction: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { followAction } = FollowingSlice.actions

export default FollowingSlice.reducer